import { ArrowDownIcon, ArrowUp, Header, IconButton } from "@datagame/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import { Content } from "./Content";
import { Game } from "../../../../../../gql/graphql";
import { isCardBasedGame } from "../../../../../../graphql/helpers/CardBasedGame";
import { isTriviaGame } from "../../../../../../graphql/helpers/isTriviaGame";
import { isWordopolisGame } from "../../../../../../graphql/helpers/isWordopolisGame";

import styles from "./Step6Preview.module.scss";

const cx = classNames.bind(styles);

type Step6PreviewProps = {
  game: Game;
};

export const Step6Preview = ({ game }: Step6PreviewProps) => {
  const { t } = useTranslation("project");
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  const renderPlaceholder = () => (
    <div className={cx("previewBody", "empty")}>
      <Header variant="h3" className={styles.placeholderTitle}>
        {t("preview.titlePlaceholder")}
      </Header>
      <span className={styles.placeholder}>{t("preview.step6Placeholder")}</span>
    </div>
  );

  const renderContent = () => {
    if (isWordopolisGame(game)) {
      if (!game.configuration.showWelcomePage) {
        return renderPlaceholder();
      }
    }
    if (isTriviaGame(game) && !game.configuration.showWelcomePage && !game.configuration.showFeedbackPage) {
      return renderPlaceholder();
    }
    if (
      !game.configuration.showWelcomePage &&
      !game.configuration.showFeedbackPage &&
      isCardBasedGame(game) &&
      !game.configuration.showGameResults
    ) {
      return renderPlaceholder();
    }

    return (
      <div className={styles.previewBody}>
        <Content game={game} />
      </div>
    );
  };

  const wrapperClassNames = cx("wrapper", { isExpanded });

  return (
    <div className={wrapperClassNames}>
      <Header variant="h5" className={styles.previewHeaderMobile}>
        <span className={styles.placeholderHeader}>{t("preview.titlePlaceholder")}</span>
        <IconButton size="small" icon={isExpanded ? <ArrowUp /> : <ArrowDownIcon />} onClick={toggleExpanded} />
      </Header>

      {renderContent()}
    </div>
  );
};
